import React, { Component } from "react";
import { StyledHeader } from "./style.js";
import { Header } from "semantic-ui-react";
import { connect } from "react-redux";

class ReportHeader extends Component {
  render() {
    const { filters } = this.props;
    const datasetUnitName =
      this.props.summaryReport && this.props.summaryReport.datasetUnitNamePlural
        ? this.props.summaryReport.datasetUnitNamePlural
        : "work settings";
    return (
      <StyledHeader>
        <Header as="h1" className={this.props.smallerHeader ? "smaller-header" : ''}>
          {this.props.title}
        </Header>
        {!this.props.unit && !/SUTTER_Pulse/.test(this.props.summaryReport.actualSurvey) && (
            <Header as="h2">
              {filters && filters.count >= 0 ? filters.count : this.props.totalRespondents} respondents in {this.props.workSettingsSurveyed} {datasetUnitName} at {this.props.datasetName} {filters && filters.count >= 0 && <span> - {filters.summary}</span>}
            </Header>
          )}
        {this.props.unit && !/SUTTER_Pulse/.test(this.props.summaryReport.actualSurvey) && (
            <Header as="h2">
              {filters && filters.count >= 0 ? filters.count : this.props.unit.responseCount} respondents in <u>{this.props.unit.name}</u>{filters && filters.count >= 0 && <span> - {filters.summary}</span>}
            </Header>
          )}
        {/SUTTER_Pulse/.test(this.props.summaryReport.actualSurvey) && (
          <Header as="h2">
            {filters && filters.count >= 0 ? filters.count : this.props.unit ? this.props.unit.responseCount : this.props.totalRespondents} respondents -{" "}
            {this.props.datasetName}{filters && filters.count >= 0 && <span> - {filters.summary}</span>}
          </Header>
        )}
      </StyledHeader>
    );
  }
}

export default connect(store => {
  return {
    filters: store.filters
  };
})(ReportHeader);


// WEBPACK FOOTER //
// ./src/components/ReportHeader/index.jsx